enum PaymentModalSteps {
  Recipients = 'recipients',
  Amount = 'amount',
  Enroll = 'enroll',
  Success = 'success',
}

export default PaymentModalSteps
